export default "/_next/static/images/9ead00ecb3729e197a8eb73bcc962416.jpg";